import { Plugin } from 'chart.js';

export type InsideTextOptions = {
    text: string;
    fontSize: number;
    color: string;
};

export const InsideTextPlugin: Plugin<'doughnut'> = {
    id: 'insideText',
    afterDatasetsDraw: function (chart, args, options) {
        const ctx = chart.ctx;
        const { text, fontSize = 22, color = "#000" } = chart.options.plugins!.insideText!;
        if (text != null) {
            const width = chart.width;
            const height = chart.height;
            const textX = Math.round(width / 2);
            const textY = Math.round(height / 2);
            ctx.font = fontSize + 'em Roboto';
            ctx.fillStyle = color;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(text, textX, textY);
        }
    }
};
